module.exports = __webpack_public_path__ + "a9e1810dffd8816f16e76c1e5ad20f79.mp4";